var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"px-0",attrs:{"items":_vm.items}}),_c('v-row',[_c('v-col',[_c('Layout1')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }